<idp-view-modal
  class="ineligibility-modal header-only-modal grey-background-modal"
  [modalOpen]="modalOpen"
  [showCloseIcon]="true"
  [showCloseBtn]="true"
  [showFooter]="false"
  [modalTitle]="content.modalHeader"
  [sideTopPaddingEnabled]="true"
  buttonStyle="primary"
  (modalCancel)="closeModal()"
  (modalDone)="closeModal()"
  (modalSave)="closeModal()"
>
  <div
    class="ineligibility-modal-content"
    [innerHTML]="content.modalDetails"
  ></div>

  <div class="ineligibility-modal-footer">
    <div class="ineligibility-modal-footer-btn-container">
      <idp-button
        [label]="content.primaryAction.label"
        [bottomSpace]="true"
        type="primary"
        elementType="button"
        size="large"
        customClass="footer-btn"
        class="upgrade-options--button td-comp-ml-save-btn"
        (click)="handleModalAction(content.primaryAction)"
        [ariaLabel]="content.primaryAction.label"
      ></idp-button>
      <idp-button
        *ngIf="content.alternateAction ? true : false"
        [label]="content.alternateAction?.label ?? ''"
        elementType="button"
        size="large"
        type="secondary"
        customClass="footer-btn"
        class="upgrade-options--button td-comp-ml-cancel-btn"
        [ariaLabel]="content.alternateAction?.label || ''"
        (click)="handleModalAction(content.alternateAction)"
      ></idp-button>
    </div>
  </div>
</idp-view-modal>
